import axios from '../../config/axios';

class DashboardRepository {
    retry = async (row) => {
        return new Promise((resolve, reject) => {
            try {
                axios.post("dashboard/retry", { ...row }).then(async (response) => {
                    resolve(response.data);
                });
            } catch (error) {
                reject(error);
            }

        })
    };

    reprocess = async (data) => {
        return new Promise((resolve, reject) => {
            try {
                axios.post("dashboard/reprocess", data).then(async (response) => {
                    resolve(response.data);
                });
            } catch (error) {
                reject(error);
            }

        })
    };

    showData = async (id) => {
        return new Promise((resolve, reject) => {
            try {
                axios.post("dashboard/get", { id }).then(async (response) => {
                    resolve(response.data);
                });
            } catch (error) {
                console.error(error);
                reject(error);
            }

        })
    };



    remove = async (id) => {
        return new Promise((resolve, reject) => {
            try {
                axios.post("dashboard/remove", { id }).then(async (response) => {
                    resolve(response.data);
                });
            } catch (error) {
                reject(error);
            }

        })
    };

    getData = async (state) => {
        return new Promise((resolve, reject) => {
            try {
                axios.post("dashboard/all", state).then(async (response) => {
                    resolve(response.data);
                });
            } catch (error) {
                reject(error);
            }

        })
    };

    hasError = async (id) => {
        return new Promise((resolve, reject) => {
            try {
                axios.post("dashboard/has-error", { id }).then(async (response) => {
                    resolve(response.data);
                });
            } catch (error) {
                reject(error);
            }

        })
    };

    updateData = async (data) => {
        return new Promise((resolve, reject) => {
            try {
                axios.post("dashboard/updateData", data).then(async (response) => {
                    resolve(response.data);
                });
            } catch (error) {
                console.error(error);
                reject(error);
            }

        })
    };

    getPerformanceData = async (data) => {
        return new Promise((resolve, reject) => {
            try {
                axios.post(`performance/get-data/${data.time}/${data.unit}`, data).then(async (response) => {
                    resolve(response.data);
                });
            } catch (error) {
                console.error(error);
                reject(error);
            }

        })
    };

    getClientList = async (data) => {
        return new Promise((resolve, reject) => {
            try {
                axios.post(`clients/get-list`, data).then(async (response) => {
                    resolve(response.data);
                });
            } catch (error) {
                console.error(error);
                reject(error);
            }

        })
    };


}
export default DashboardRepository;
